import { render, staticRenderFns } from "./statusPanel.vue?vue&type=template&id=5431fdfd&scoped=true&"
import script from "./statusPanel.vue?vue&type=script&lang=js&"
export * from "./statusPanel.vue?vue&type=script&lang=js&"
import style0 from "./statusPanel.vue?vue&type=style&index=0&id=5431fdfd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431fdfd",
  null
  
)

export default component.exports